// Libraries
import React from 'react';
import ReactDOM from 'react-dom';

import { Index as IndexBusiness } from './__business'
import { Index as IndexPersonal } from './__personal';

// Import the database provider
import { DbProvider } from './db/db-context';
// added import for global snackbars
import { SnackbarProvider } from './core/context/SnackbarContext';
import GlobalSnackbar from './core/global/GlobalSnackbar';

const loc = window.location.pathname
const subdir = loc.split('/')[1]
let Core = IndexPersonal;

if (subdir === 'biz') {
	Core = IndexBusiness
} else {
  	Core = IndexPersonal
}
// else{
//	Core = IndexBusiness
//	Core = IndexPersonal
// }

// Wrap Core with DbProvider
ReactDOM.render(
	<DbProvider>
		<SnackbarProvider>
			<GlobalSnackbar />
			<Core />
		</SnackbarProvider>
	</DbProvider>,
  	document.getElementById('root')
);

// Create root and render
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <DbProvider>
//     <SnackbarProvider>
//       <GlobalSnackbar />
//       <Core />
//     </SnackbarProvider>
//   </DbProvider>
// );
